import { Page } from '@/components/common/page';
import { AppSections } from '@/enums/app-sections.enums';
import { AllAppsSection } from '@/features/applications/components/all-apps-section';
import { useApplicationLaunch } from '@/hooks/use-application-launch.queries';

function ApplicationsPage() {
  const { loadingAppId, launchApplication } = useApplicationLaunch();

  return (
    <Page>
      <section id={AppSections.ALL_APPS}>
        <AllAppsSection
          onApplicationClick={launchApplication}
          loadingAppId={loadingAppId}
        />
      </section>
    </Page>
  );
}

export default ApplicationsPage;
